import React from "react";

// Creating the context object and passing the default values.
const ThemeContext = React.createContext({ isMobileScreen: false });

export default ThemeContext;
